import AdjuntosClass from "src/app/model/api/datos/adjuntosClass";
import Paging from "src/app/model/api/generic/paging";
import DatabaseTable from "src/app/model/database/generic/databaseTable";

export default class AdjuntosTable extends DatabaseTable<AdjuntosClass> {
    
    public async getAll(): Promise<AdjuntosClass[]> {
        return await this.GetAllRecords()
    }

    public async getById(Id: number): Promise<AdjuntosClass> {
        let records = await this.GetRecordsByIndex(0, 1, 'Id', Id, Id)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async getByLocalId(Id: number): Promise<AdjuntosClass> {
        let records = await this.GetRecordsById(0, 1, Id, Id)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async getByOrdenLocalId(OrdenLocalId: number): Promise<AdjuntosClass[]> {
        let records = await this.GetRecordsByIndex(0, Number.MAX_VALUE, 'OrdenLocalId', OrdenLocalId, OrdenLocalId)
        return records
    }

    public async update(record: AdjuntosClass): Promise<number> {
        return await this.UpdateRecord(record)
    }

    public async delete(record: AdjuntosClass): Promise<void> {
        if (!record?.LocalId) return
        await this.DeleteRecord(record.LocalId)
    }

}